// Display number formatting. Integer only; > 999 abbreviates with truncation.

const ABBREV_UNITS = ['', 'k', 'M', 'B'] as const;

// Values below 1000 print exactly; above that they abbreviate to one decimal
// place, truncated — 1999 → '1.9k', never '2.0k'. At two digits the decimal
// stops paying for itself and drops: 45_231 → '45k'.
export function formatInt(value: number): string {
  if (!Number.isFinite(value)) return '0';
  const neg = value < 0;
  let v = Math.floor(Math.abs(value));
  if (v < 1000) return neg ? '-' + v : String(v);
  let unit = 0;
  while (v >= 1000 && unit < ABBREV_UNITS.length - 1) {
    v = v / 1000;
    unit++;
  }
  // Truncate to 1dp so 1999 → "1.9k", never "2.0k".
  const truncated = Math.floor(v * 10) / 10;
  const body = truncated >= 10 ? String(Math.floor(truncated)) : truncated.toFixed(1);
  return (neg ? '-' : '') + body + ABBREV_UNITS[unit];
}
